import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { RatingInput } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RatingInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RatingInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const RatingInput_RatingInput = (t0)=>{
    const $ = c(49);
    let chipMaxWidth;
    let iconSize;
    let items;
    let label;
    let name;
    let onChange;
    let required;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let testId;
    let tooltip;
    let type;
    if ($[0] !== t0) {
        ({ type, label, name, onChange, items, required, disabled: t1, size: t2, iconSize, showError: t3, loading: t4, tooltip, testId, fillMode: t5, highlightRange: t6, showLabelBelow: t7, validateArray: t8, chipMaxWidth } = t0), rest = _object_without_properties(t0, [
            "type",
            "label",
            "name",
            "onChange",
            "items",
            "required",
            "disabled",
            "size",
            "iconSize",
            "showError",
            "loading",
            "tooltip",
            "testId",
            "fillMode",
            "highlightRange",
            "showLabelBelow",
            "validateArray",
            "chipMaxWidth"
        ]);
        $[0] = t0;
        $[1] = chipMaxWidth;
        $[2] = iconSize;
        $[3] = items;
        $[4] = label;
        $[5] = name;
        $[6] = onChange;
        $[7] = required;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = testId;
        $[18] = tooltip;
        $[19] = type;
    } else {
        chipMaxWidth = $[1];
        iconSize = $[2];
        items = $[3];
        label = $[4];
        name = $[5];
        onChange = $[6];
        required = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        t5 = $[13];
        t6 = $[14];
        t7 = $[15];
        t8 = $[16];
        testId = $[17];
        tooltip = $[18];
        type = $[19];
    }
    const disabled = void 0 === t1 ? false : t1;
    const size = void 0 === t2 ? "large" : t2;
    const showError = void 0 === t3 ? true : t3;
    const loading = void 0 === t4 ? false : t4;
    const fillMode = void 0 === t5 ? true : t5;
    const highlightRange = void 0 === t6 ? false : t6;
    const showLabelBelow = void 0 === t7 ? false : t7;
    let t9;
    if ($[20] !== t8) {
        t9 = void 0 === t8 ? [] : t8;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    const validateArray = t9;
    let t10;
    if ($[22] !== validateArray) {
        t10 = composeValidators(validateArray);
        $[22] = validateArray;
        $[23] = t10;
    } else t10 = $[23];
    const validators = t10;
    let t11;
    if ($[24] !== onChange || $[25] !== type) {
        t11 = (input)=>(nextValue)=>{
                const convertedVal = "number" === type && "string" == typeof nextValue ? parseInt(nextValue, 10) : nextValue;
                input.onChange(convertedVal);
                if (onChange) onChange(convertedVal);
            };
        $[24] = onChange;
        $[25] = type;
        $[26] = t11;
    } else t11 = $[26];
    const handleChange = t11;
    let t12;
    if ($[27] !== chipMaxWidth || $[28] !== disabled || $[29] !== fillMode || $[30] !== handleChange || $[31] !== highlightRange || $[32] !== iconSize || $[33] !== items || $[34] !== label || $[35] !== loading || $[36] !== required || $[37] !== showError || $[38] !== showLabelBelow || $[39] !== size || $[40] !== testId || $[41] !== tooltip) {
        t12 = (t13)=>{
            const { input: input_0, meta } = t13;
            return /*#__PURE__*/ jsx(RatingInput, _object_spread_props(_object_spread({}, input_0), {
                testId: testId,
                items: items,
                tooltip: tooltip,
                value: input_0.value,
                onChange: handleChange(input_0),
                size: size,
                iconSize: iconSize,
                required: required,
                error: showError && meta.touched && !!meta.error,
                helperText: showError && meta.touched && meta.error,
                label: label,
                loading: loading,
                disabled: disabled,
                activeSingleOption: false,
                fillMode: fillMode,
                highlightRange: highlightRange,
                showLabelBelow: showLabelBelow,
                chipMaxWidth: chipMaxWidth
            }));
        };
        $[27] = chipMaxWidth;
        $[28] = disabled;
        $[29] = fillMode;
        $[30] = handleChange;
        $[31] = highlightRange;
        $[32] = iconSize;
        $[33] = items;
        $[34] = label;
        $[35] = loading;
        $[36] = required;
        $[37] = showError;
        $[38] = showLabelBelow;
        $[39] = size;
        $[40] = testId;
        $[41] = tooltip;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== disabled || $[44] !== name || $[45] !== rest || $[46] !== t12 || $[47] !== validators) {
        t13 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name,
            validate: validators,
            disabled: disabled
        }, rest), {
            children: t12
        }));
        $[43] = disabled;
        $[44] = name;
        $[45] = rest;
        $[46] = t12;
        $[47] = validators;
        $[48] = t13;
    } else t13 = $[48];
    return t13;
};
export { RatingInput_RatingInput as RatingInput };
